module.exports = "<div class=\"search\">\n  <div class=\"search__img\"></div>\n  <div class=\"wrapper search__wrapper\">\n    <h2 class=\"page-title\">{{appconfig.labels.page_title}}</h2>\n  </div>\n</div>\n<div class=\"wrapper confirmation\">\n  <h3 class=\"error__headline\">{{appconfig.common_sys_err1}}</h3>\n  <p *ngIf=\"commonSysErr\">{{appconfig.common_sys_err2}}</p>\n  <a role=\"button\" class=\"btn btn-error\" href=\"/\">Return to Homepage</a>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/error/error.component.html
// module id = ../../../../../src/app/error/error.component.html
// module chunks = main